import React, { useContext } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import './styles.css'
import App from './app'
import CV from './pages/CV'
import Exhibitions from './pages/Exhibitions'
import Articles from './pages/Articles'
import Workshops from './pages/Workshops'
import Contact from './pages/Contact'
import { LanguageProvider, LanguageContext } from './context/LanguageContext'
import LanguageSwitcher from './components/LanguageSwitcher'
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PrivateRoute from './components/PrivateRoute';
import { Analytics } from '@vercel/analytics/react';
import AtelieAberto from './pages/AtelieAberto';
import FioDeRio from './pages/FioDeRio';

function Root() {
  const location = useLocation();
  const { language } = useContext(LanguageContext);

  const texts = {
    EN: {
      nav: {
        cv: "CV",
        // exhibitions: "exhibitions",
        articles: "texts & publications", // Atualizado aqui
        workshops: "workshops",
        contact: "contact"
      },
      scroll: "scroll up/down to navigate",
      back: "back"
    },
    PT: {
      nav: {
        cv: "bio + CV",
        // exhibitions: "exposições",
        articles: "publicações", // Atualizado aqui
        workshops: "workshops",
        contact: "contato"
      },
      scroll: "role para cima/baixo para navegar",
      back: "retornar"
    }
  };

  const t = texts[language];

  return (
    <>
      <LanguageSwitcher />
      <AnimatePresence mode="wait">
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={
            <>
              <App />
              <div style={{ position: 'absolute', pointerEvents: 'none', top: 0, left: 0, width: '100vw', height: '100vh' }}>
                <a href="https://wagnerorniz.com" className="site-title">
                  Wagner Orniz
                </a>
                <div style={{ position: 'absolute', bottom: 40, right: 40, fontSize: '13px', display: 'flex', gap: '20px' }}>
                  <Link to="/cv" className="nav-link" style={{ pointerEvents: 'auto', textDecoration: 'none', color: 'black' }}>{t.nav.cv}</Link>
                  {/* <Link to="/exhibitions" className="nav-link" style={{ pointerEvents: 'auto', textDecoration: 'none', color: 'black' }}>{t.nav.exhibitions}</Link> */}
                  <Link to="/articles" className="nav-link" style={{ pointerEvents: 'auto', textDecoration: 'none', color: 'black' }}>{t.nav.articles}</Link>
                  <Link to="/workshops" className="nav-link" style={{ pointerEvents: 'auto', textDecoration: 'none', color: 'black' }}>{t.nav.workshops}</Link>
                  <Link to="/contact" className="nav-link" style={{ pointerEvents: 'auto', textDecoration: 'none', color: 'black' }}>{t.nav.contact}</Link>
                </div>
                <a className="scroll-text" style={{ position: 'absolute', bottom: 40, left: 90, fontSize: '13px' }} href="#">
                  {t.scroll}
                </a>
              </div>
            </>
          } />
          <Route path="/cv" element={<CV />} />
          <Route path="/exhibitions" element={<Exhibitions />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/workshops" element={<Workshops />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route 
            path="/dashboard" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route path="/workshops/atelie-aberto" element={<AtelieAberto />} />
          <Route path="/fio-de-rio" element={<FioDeRio />} />
        </Routes>
      </AnimatePresence>
      <Analytics />
    </>
  )
}

function AppWrapper() {
  return (
    <LanguageProvider>
      <Router>
        <Root />
      </Router>
    </LanguageProvider>
  )
}

createRoot(document.getElementById('root')).render(<AppWrapper />)
